import './row-boxes.scss';
import Splide from '@splidejs/splide';

export class RowBoxes {
  constructor() {
    this.el = document.querySelector('.js-row-boxes-slider');
    if (!this.el) return;

    this.breakpoint = 992;
    this.splide = null;

    // Conta le card
    this.cards = this.el.querySelectorAll('.splide__slide').length;

    this.init();
  }

  init() {
    this.checkSlider();
    window.addEventListener('resize', () => this.checkSlider());
  }

  checkSlider() {
    const isMobile = window.innerWidth < this.breakpoint;
    const hasManyCards = this.cards >= 6;

    // Condizione per attivare lo slider
    const shouldInit = isMobile || hasManyCards;

    if (shouldInit && !this.splide) {
      this.initSlider();
    }

    if (!shouldInit && this.splide) {
      this.destroySlider();
    }
  }

  initSlider() {
    this.splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '1.5rem',
      perPage: 5,
      focus: 0,
      trimSpace: true,
      snap: true,
      breakpoints: {
        1280: {
          perPage: 4,
        },
        992: {
          perPage: 3,
        },
        768: {
          perPage: 1.5,
        },
      },
    });

    this.splide.mount();

    const prev = this.el.querySelector('.splide__arrow--prev');
    const next = this.el.querySelector('.splide__arrow--next');

    const updateArrows = () => {
      if (!prev || !next) return;

      const { index } = this.splide;
      const last = this.splide.length - this.splide.options.perPage;

      prev.classList.toggle('is-disabled', index === 0);
      next.classList.toggle('is-disabled', index >= last);
    };

    updateArrows();
    this.splide.on('mounted move', updateArrows);

    if (prev) prev.addEventListener('click', () => this.splide.go('<'));
    if (next) next.addEventListener('click', () => this.splide.go('>'));
  }

  destroySlider() {
    this.splide.destroy(true);
    this.splide = null;
  }
}
